import React from 'react';
import CybsButton from '@cybs-ui/components/lib/button';
import {connect} from 'react-redux';
import {loadUrlInNewTab, downloadFileFromLink} from '../../../../../libs/common-library';
import '../css/rhs-header.css';
import { nodeName } from 'jquery';
import {getPartnerName} from "../../../../../lhs/reducers/configuration-reducer";

class developerGuides extends React.Component{

  handleButtonClick = () => {
    if(window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'cybsd_spec_button_click',
        buttonID: 'cybsd_spec_cta',
      });
    }
    downloadFileFromLink(getPartnerName() + '_merged',this.props.specDownloadLink)
  };

  componentDidMount() {
    const button = document.getElementById('specs_cta');
    if (button) {
      button.addEventListener('click', this.handleButtonClick);
    }
  }

  componentWillUnmount() {
    const button = document.getElementById('specs_cta');
    if (button) {
      button.removeEventListener('click', this.handleButtonClick);
    }
  }

  render(){
    return(
      <div class = "DeveloperGuides">
        { this.props.thirdLevelApiLifeCycle != 'new' && this.props.thirdLevelApiLifeCycle != 'hidden' && this.props.thirdLevelApiLifeCycle != 'pilot' &&
          <span id = "specs_cta">
            <CybsButton
              aria-label="Download the API specifications"
              dataTest="secondaryButton"
              i18n={{ label: 'Download API Specification' }}
              resolution = "low"
              className = "border_color_theme_primary"
              colorScheme="secondary"
            />

          </span>
        }
        { this.props.developerGuideLink && 
          <span id = "developerGuides">
            <CybsButton
              aria-label="View Developer Guide"
              dataTest="secondaryButton"
              i18n={{ label: 'Developer Guides' }}
              resolution = "low"
              iconClass = "code-run"
              iconLocation = "left"
              className = "border_color_theme_primary"
              onClick={() =>loadUrlInNewTab(this.props.developerGuideLink)}
              colorScheme="secondary"
            />
          </span>
        }
      </div>
      
    )
    }
 
}

function mapStateToProps(state){
  return{
    developerGuideLink: state.rhsReducer.developerGuideLink,
    specDownloadLink: state.rhsReducer.specDownloadLink,
    thirdLevelApiLifeCycle: state.lhsReducer.thirdLevelApiLifeCycle
  }
}

export default connect(mapStateToProps)(developerGuides);
